import {Controller, useFormContext} from "react-hook-form";
import React, {useContext} from "react";
import {UserContext} from "../../contexts/UserContext";
import {ProjectContext} from "../../contexts/ProjectContext";
import {FormControl, FormItem, FormLabel} from "../ui/form";
import {Input} from "../ui/input";
import {AutosizeTextarea} from "../ui/autoresizeTextArea";
import {CompanyType} from "../../models/company";
import {VEListItem} from "../ve/ve_model";
import {moneyFormatter, onChangeMoneyField} from "../../lib/formatters";
import {Select} from "@radix-ui/react-select";
import {ScopesSelector} from "../scope/ScopeSelector"


interface SubFormProps {
    disabled: boolean;
    hidden: boolean;
    show_title?: boolean;
    entity: VEListItem | null;
}

interface withVEListItem {
    entity: VEListItem | null;
}


export function SuggestedByLine({entity}: withVEListItem) {
    const projectContext = useContext(ProjectContext);
    const userContext = useContext(UserContext);
    return (
        <div className="mt-2 text-xs ">
            <span>Suggested by : </span>
            <span>{
                // if we the suggestion was created by someone in our comapny, show the name,
                // otherwise it iwll not be available
                (
                    entity?.suggestion?.created_by?.company.id === userContext?.company_id)
                || projectContext?.role === CompanyType.developer
                    ? <>
                        <span>{entity?.suggestion?.created_by?.email}</span>
                        <span> - </span>
                        <span>{entity?.suggestion?.created_by?.company.name}</span>
                    </>
                    : "by others"
            }</span>
        </div>
    )
}

export const SuggestionForm = ({disabled, hidden, entity}: SubFormProps) => {
    const {control} = useFormContext();
    const projectContext = React.useContext(ProjectContext);
    if (hidden) {
        return <></>
    }
    // console.log(projectContext)
    // console.log(entity)
    return <>
        <Controller
            name={`suggestion.title`}
            control={control}
            disabled={disabled}
            render={({field}) =>
                <FormItem>
                    <FormLabel>Title</FormLabel>
                    <FormControl>
                        {disabled ? (
                                <div className="mt-2">
                                    <span>{field.value || "N/A"}</span>
                                </div>)
                            :
                            <Input className="w-full"
                                   data-test-id="suggestion.title"
                                   {...field}
                                   value={field.value ? field.value : ""}
                                   onChange={field.onChange}
                                   placeholder="Title"/>}
                    </FormControl>
                </FormItem>}
        />
        <Controller
            name={`suggestion.description`}
            control={control}
            disabled={disabled}
            render={({field}) =>
                <FormItem>
                    <FormLabel>Description</FormLabel>
                    <FormControl>
                        {disabled ? (
                                <div className="mt-2">
                                    <span>{field.value || "N/A"}</span>
                                </div>)
                            :
                            <AutosizeTextarea className="w-full" {...field} placeholder="Description"/>}
                    </FormControl>
                </FormItem>}
        />
        <Controller
            name={`suggestion.scope_id`}
            control={control}
            disabled={disabled}
            render={({field}) =>
                <FormItem>
                    <FormLabel>Scope</FormLabel>
                    <FormControl>
                        {disabled ? (
                                <div className="mt-2">
                                    <span>{projectContext?.scopes.find(
                                        x => x._id === field.value)?.title || "N/A"
                                    }</span>
                                </div>)
                            :
                            <ScopesSelector value={field.value} handleSelect={field.onChange}/>
                        }
                    </FormControl>
                </FormItem>}
        />

    </>
};


export const PriceForm = ({disabled, show_title, hidden}: SubFormProps) => {
    const {control} = useFormContext();
    const projectContext = React.useContext(ProjectContext);
    if (hidden) {
        return <></>
    }
    return (
        <>
            {show_title &&
                <Controller
                    name="price.title"
                    control={control}
                    disabled={disabled}
                    render={({field}) =>
                        <FormItem>
                            <FormLabel>Title</FormLabel>
                            <FormControl>
                                {disabled
                                    ? (<div className="mt-2">
                                        <span>{field.value || "N/A"}</span>
                                    </div>)
                                    : <Input className="w-full" {...field}
                                             value={field.value ? field.value : ""}
                                             onChange={field.onChange}
                                             placeholder="Title"/>}
                            </FormControl>
                        </FormItem>
                    }
                />
            }
            <Controller
                name="price.savings_amount"
                control={control}
                disabled={disabled}
                render={({field}) =>
                    <FormItem>
                        <FormLabel>Savings Amount *</FormLabel>
                        {disabled

                            ? (<div className="mt-2">
                                <span>{field.value ? moneyFormatter.format(Number(field.value)) : "N/A"}</span>
                            </div>)

                            : <Input
                                {...field}
                                className="w-full"
                                placeholder="Savings Amount"
                                value={field.value ? moneyFormatter.format(Number(field.value)) : ""}
                                required={true}
                                onChange={(e) => onChangeMoneyField(field, e)}
                            />
                        }
                    </FormItem>
                }
            />
            <Controller
                name={`suggestion.scope_id`}
                control={control}
                disabled={disabled}
                render={({field}) =>
                    <FormItem>
                        <FormLabel>Scope</FormLabel>
                        <FormControl>
                            {disabled ? (
                                    <div className="mt-2">
                                        <span>{projectContext?.scopes.find(
                                            x => x._id === field.value)?.title || "N/A"
                                        }</span>
                                    </div>)
                                :
                                <ScopesSelector value={field.value} handleSelect={field.onChange}/>
                            }
                        </FormControl>
                    </FormItem>}
            />
            <Controller
                name="price.description"
                control={control}
                disabled={disabled}
                render={({field}) =>
                    <FormItem>
                        <FormLabel>Notes</FormLabel>
                        {disabled ? (
                                <div className="mt-2">
                                    <span>{field.value || "N/A"}</span>
                                </div>)
                            : <AutosizeTextarea
                                {...field}
                                value={field.value ? field.value : ""}
                                onChange={field.onChange}
                                placeholder=""/>}
                    </FormItem>

                }
            />
            {/*price description*/}
        </>
    );
};